import getTarget from 'javascripts/utils/get-target';

class ThumbRating {
  constructor($el) {
    this.$el = $el;
    this.$ratingButtons = this.$el.querySelectorAll('.thumb-rating__item[href]');

    if (this.$ratingButtons) {
      $el.addEventListener('click', this.handleRatingClick);
    }
  }

  handleRatingClick = (event) => {
    const target = getTarget(event.target, '.thumb-rating__item[href]');

    if (target && target.dataset.chosen !== 'true') {
      const value = parseInt(target.dataset.value, 10);
      const newValue = value + 1;

      // Reset existing chosen button (if one chosen.)
      this.$ratingButtons.forEach(($el) => {
        const $button = $el;
        if ($button.dataset.chosen === 'true') {
          const chosenValue = parseInt($button.dataset.value, 10);
          const chosenNewValue = chosenValue - 1;
          $button.dataset.value = chosenNewValue;
          $button.querySelector('.thumb-rating__value').textContent = chosenNewValue;
          $button.dataset.chosen = '';
        }
      });

      target.dataset.chosen = 'true';
      target.dataset.value = newValue;
      target.querySelector('.thumb-rating__value').textContent = newValue;
    }
  }
}

const componentStore = [];
document.querySelectorAll('.thumb-rating').forEach($el => componentStore.push(new ThumbRating($el)));
